<template>
    <div class="container">
        <div class="row">
            <div id="first" class="col-12 px-0 d-flex justify-content-center justify-content-lg-start"
                style="overflow-x:hidden;">
                <keep-alive>
                    <transition-group name="router-anim-bg" mode="out-in" appear>
                        <img v-for="i in [currentIndex]" :key="i" :src="currentImg" alt="Imagem de Fundo" />
                    </transition-group>
                </keep-alive>
                <!-- SECTION-LOGIN -->
                <div id="section-login" class="active col-12 col-md-5 col-lg-4 col-xl-3 px-0 d-flex align-items-center">
                    <transition name="router-anim-home" mode="out-in" appear>
                        <component :is="status.box" :status="status" :resale="resale" />
                    </transition>
                </div>
                <div id="section-home" class="p-0 d-none d-lg-flex position-absolute w-75">
                    <header class="mt-lg-5 ml-5">
                        <ul class="d-flex p-0 w-100 text-break">
                            <li>
                                <router-link to="/funcionalidades">FUNCIONALIDADES</router-link>
                            </li>
                            <li>
                                <router-link to="/nossos-planos">PLANOS</router-link>
                            </li>
                            <li><a :href="resale.link_site" target="_blank">EMPRESA</a></li>
                            <li>
                                <router-link to="/contato">Contato</router-link>
                            </li>
                            <li>
                                <router-link to="/dicas">Termos e Dicas</router-link>
                            </li>
                        </ul>
                    </header>
                </div>
                <ol class="carousel-indicators position-xs-relative position-md-absolute w-100 w-md-75 ml-0"
                    style="z-index:auto;">
                    <li v-for="(img, i) in images.length" @click="handleImg(i)" :key="i"
                        :class="{'active': currentIndex==i}" class="border-dark"></li>
                </ol>
                <transition name="anim-cookies" mode="in-out" appear>
                    <div id="cookies" v-show="(cookies==null)"
                        class="col-10 offset-1 col-md-8 offset-md-2 position-fixed bg-white text-justify py-3 px-5">
                        Nós usamos cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossos
                        serviços. Aoutilizar nossos serviços, você concorda com tal monitoramento. Conheça nossa
                        <router-link to="/dicas" target="_blank">Politica de utilização de Cookies
                        </router-link>.
                        <button @click="setCookie()" class="btn btn-success float-right mr-lg-5 py-0 px-lg-2"
                            name="Aceitar-Cookies">Aceitar</button>
                    </div>
                </transition>
                <span v-if="position" class="fixed-bottom">
                    <button class="btn btn-warning px-3" @click="scrollTop">
                        <i class="fa fa-arrow-up"></i>
                    </button>
                </span>
            </div>
            <template v-if="screen" class="col-12 position-relative">
                <div class="d-block d-lg-none col-12 p-0">
                    <funcionalidades v-bind="{screen}" />
                </div>
                <div class="d-block d-lg-none col-12 p-0">
                    <planos v-bind="{screen, status}" />
                </div>
                <div class="d-block d-lg-none col-12 p-0">
                    <contato v-bind="{screen}" />
                </div>
                <div class="d-block d-lg-none col-12 p-0">
                    <dicas v-bind="{screen}" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie';
    import login from '../auth/Login.vue';
    import cadastrar from '../auth/cadastro.vue';
    import cadastroSignatario from '../auth/cadastroSignatario.vue';
    import recoveryPassword from '../auth/RecoveryPassword.vue';
    import resetPassword from '../auth/ResetPassword.vue';
    import funcionalidades from './components/funcionalidades.vue';
    import planos from './components/planos.vue';
    import contato from './components/contato.vue';
    import dicas from './components/dicas.vue';
    export default {
        components: {
            login,
            cadastrar,
            cadastroSignatario,
            recoveryPassword,
            resetPassword,
            funcionalidades,
            planos,
            contato,
            dicas,
        },
        data() {
            return {
                cookies: '',
                images: [
                    require("@/assets/login/Tela docx.jpg"),
                    require("@/assets/login/Tela docx2.jpg"),
                    require("@/assets/login/Tela docxassinatura.jpg"),
                    require("@/assets/login/Tela docxsustentabilidade.jpg"),
                ],
                resale: {
                    id: process.env.VUE_APP_DEFAULT_RESALE,
                    logo: require('@/assets/login/Logo.png'),
                    link_domain: window.location.hostname,
                    link_site: 'https://armbd.com.br/?tag=about',
                    link_facebook: 'https://www.facebook.com/mbdsolucoes/',
                    link_instagram: 'https://www.instagram.com/docxdigitalassinatura/',
                    link_linkedin: 'https://www.linkedin.com/company/1056719',
                    link_youtube: 'https://www.youtube.com/channel/UCZC-ve4TCMkUq4x9qiYnOfQ',
                    loading: false,
                },
                currentIndex: 0,
                interval: Function,
                status: {
                    box: 'login',
                },
                screen: true,
                position: false,
            }
        },
        computed: {
            currentImg: function () {
                return this.images[Math.abs(this.currentIndex) % this.images.length];
                // return this.images[0];
            },
        },
        beforeMount() {
            switch (this.$route.name) {
                case 'resetPassword':
                case 'storeUser':
                    this.status.box = 'resetPassword';
                    break;
                case 'confirmarCadastroVinculo':
                case 'cadastroSignatario':
                    this.status.box = 'cadastroSignatario';
                    break;
                default:
                    if (this.$route.params.plano) {
                        this.status.box = 'cadastrar';
                        this.status.plano = this.$route.params.plano;
                    } else this.status.box = 'login';
            }
            setTimeout(() => {
                this.cookies = Cookies.get('politica')
            }, 1500);
        },
        mounted() {
            this.currentIndex = Math.round(Math.random() * (3 - 0) + 0);
            this.startCarousel();
            this.screen = ($(window).width() <= 992);
            $(window).resize(() => {
                this.screen = ($(window).width() <= 992);
            });
            $(window).scroll(() => {
                this.position = (window.pageYOffset > (window.innerHeight));
            });
            // if (!['localhos', '192.168.'].includes(this.resale.link_domain.slice(0, 7)))
            this.getResale();
        },
        methods: {
            getResale() {
                this.resale.loading = true;
                this.$store.dispatch('getResale', this.resale.link_domain).then(response => {
                    this.resale.id = response.id || this.resale.id;
                    this.resale.logo = response.logo || this.resale.logo;
                    this.resale.link_domain = response.link_domain || this.resale.link_domain;
                    this.resale.link_site = response.link_site || this.resale.link_site;
                    this.resale.link_facebook = response.link_facebook || this.resale.link_facebook;
                    this.resale.link_instagram = response.link_instagram || this.resale.link_instagram;
                    this.resale.link_linkedin = response.link_linkedin || this.resale.link_linkedin;
                    this.resale.link_youtube = response.link_youtube || this.resale.link_youtube;
                }).catch(error => {
                    toastr({
                        title: error.message,
                        icon: error.status
                    });
                }).finally(() => {
                    this.resale.loading = false;
                });
            },
            startCarousel() {
                this.interval = setInterval(() =>
                    (this.currentIndex < this.images.length) ? this.currentIndex++ : this.currentIndex = 0, 15000);
            },
            handleImg(payload) {
                this.currentIndex = payload;
                clearInterval(this.interval)
                this.startCarousel();
            },
            setCookie() {
                this.cookies = true;
                Cookies.set('politica', this.cookies, {
                    expires: 365
                })
                this.$forceUpdate()
            },
            scrollTop() {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap.min.css"></style>
<style scoped>
    #app .container {
        max-width: 100%;
    }

    #first {
        height: 100vh;
    }

    img {
        width: 100%;
        height: 100%;

        position: fixed;
        left: 0;
        z-index: -999;
    }

    .carousel-indicators li {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 0.3em;
        margin-left: 0.3em;
        border: 1px solid #fff;
    }

    /* ----- SECTION-LOGIN ----- */
    #section-login {
        width: 100%;
        height: 100vh;
        position: absolute;
        right: 3vh;
    }


    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }

    @keyframes home {
        from {
            transform: translateX(30vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .router-anim-bg-enter-active {
        animation: coming-bg 0.6s;
        animation-duration: 1s;
    }

    .router-anim-bg-leave-active {
        animation: going-bg 0.6s;
        animation-duration: 1s;
    }

    @keyframes coming-bg {
        from {
            transform: translateX(100vw);
        }

        to {
            transform: translateX(0);
        }
    }

    @keyframes going-bg {
        from {
            transform: translateX(0);
        }

        to {
            transform: translateX(-100vw);
        }
    }

    /* ----- SECTION-HOME ----- */
    #section-home {
        color: #fff;
        width: 100vw;
    }

    #section-home ul {
        list-style: none;
        align-items: center;
        justify-content: space-between;
    }

    #section-home li a {
        padding: 1rem;
        transition: all 0.3s;
        font-size: 16px;
        color: #fff;
        font-family: "Montserrat";
        font-weight: 300;
        line-height: 1.3;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        cursor: pointer;
    }

    #section-home li:hover a {
        color: #ff7f00;
        text-decoration: underline;
        border-radius: 5px;
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    @media screen and (max-width: 767px) {
        #section-login {
            max-width: 50%;
            right: auto;
        }
    }

    @media screen and (max-width: 576px) {
        #section-login {
            max-width: 100%;
            right: 0;
        }
    }

    @media screen and (max-width: 991px) {
        img {
            width: auto;
        }

        @keyframes home {
            from {
                transform: translateX(100vw);
            }

            to {
                transform: translateX(0);
            }
        }
    }

    #cookies {
        border-radius: 5px;
        bottom: 1rem;
        left: 0;
        z-index: 9999;
        -webkit-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        -moz-box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
        box-shadow: 2px 2px 12px 1px rgba(0, 0, 0, 1);
    }

    .anim-cookies-enter-active {
        animation: cookies 0.6s;
    }

    .anim-cookies-leave-active {
        animation: cookies 0.6s;
        animation-direction: reverse;
    }

    @keyframes cookies {
        from {
            transform: translateY(10vw);
        }

        to {
            transform: translateX(0);
        }
    }

    .fixed-bottom {
        right: auto;
        left: 5px;
        bottom: 5px;
    }

    .router-anim-home-enter-active {
        animation: home 0.6s;
    }

    .router-anim-home-leave-active {
        animation: home 0.6s;
        animation-direction: reverse;
    }
</style>